<template>
  <div class="container-fluid">
    <b-alert
      v-model="showAlert"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="success"
      dismissible
    >
      {{alertMessage}}
    </b-alert>
    <!-- for loading page -->
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <!--confirm box-->
    <app-confirm :message="'Delete?'" :show="showConfirmBox" @confirmed="confirmedDelete" @cancel="showConfirmBox=false" ></app-confirm>
      <!-------New Panel-------->
      <div class="row mt-4">
          <img
            class="thumbnail-rounded"
            :src="activeVersion.thumbnail"
            @error="altImg"
            id="iconThumbnail"
            width="100px" height="100px"
          >
          <div class="col">
              <h2>{{currentApp.name}}</h2>
              <div>{{appInformation.bundleId}}</div>
              <div>Current Version {{activeVersion.version || 'Null ** Please upload file first **' }}
                <b-button v-if="!currentApp.noVersion" variant="link" @click="goToAppLanding">Download Page</b-button>
                <b-button variant="link right-link-buttons" @click="requestDeleteConfirmBox('app')">Delete App</b-button>
                <b-button variant="link right-link-buttons" @click="() => $router.push({ name: 'apps2-edit-2' })">Edit App Info</b-button>
                <b-button v-if="!currentApp.noVersion" variant="link right-link-buttons" @click="goToDetail">Version Detail</b-button>
                <b-button v-if="!currentApp.noVersion" variant="link right-link-buttons" @click="() => $router.push({name: 'apps2-home-2'})">Back to List</b-button>
              </div>
          </div>
      </div>
      <div class="row mt-4 mt-4-border">
          <b-form-file   v-model="file"
      :state="Boolean(file)"
      @change="processFileInput"
      :placeholder="appExtAllow"
      drop-placeholder="Drop file here..."
      accept=".ipa, .apk"></b-form-file>
      </div>
      <div v-for="cv in listAppVersions" :key="cv.id" class="row versionRow"  @click="viewVersion(cv.id)">
        <div class="col">
          <h3>{{cv.version}}</h3>
          <div><small>{{getReleaseDate(cv.createdAt)}}</small></div>
          <div class="appSummary">{{cv.noteNew}}</div>
        </div>
      </div>
  </div>

</template>
<script>
import * as appstore from '@/helpers/appstore.js';
import * as general from '@/helpers/general.js';
import { dateToStringWithTimeFull } from '@/assets/utils/time.js';
import AppInfoParser from '@/helpers/pkg-parser/index.js';
import Loading from '@/components/Loading';
import ConfirmBox from '@/components/ConfirmBox';
import axios from 'axios';

export default {
  name: 'AppDetail',
  data () {
    return {
      currentApp: {},
      currentVersion: {},
      activeVersion: {},
      listAppVersions: [],
      appId: '',
      versionId: '',
      currentVersionText: 'Current Version',
      tooltipTextCopyApp: 'Copy App Detail',
      tooltipTextCopyPIN: 'Copy PIN',
      delTarget: '',
      alertMessage: '',
      altImage: require('@/assets/notavailable.png'),
      images: [],
      saveDone: false,
      loading: false,
      isLoading: false,
      isDetail: false,
      showCarousel: false,
      isAdmin: false,
      current: true,
      noVersion: false,
      showAlert: false,
      showConfirmBox: false,
      usedPin: true,
      activeId: null,
      routeAppsLanding: 'appsLanding2',
      routeAppsLandingWithVersion: 'appsLanding2withVersion',
      routeAppsHome: 'apps2-home-2',
      routeAppsVersion: 'apps2-version-2',
      routeAppsVersionEdit: 'app2-version-edit-2',
      routeAppsEdit: 'apps2-edit-2',
      routeAppsCreate: 'apps2-create-2',
      routeNumber2: '-2',
      routeAppsDetail: 'apps2-details-2',
      file: null,
      appVersion: {},
      appExtAllow: '',
      appInformation: {}
    };
  },
  created: function () {
    document.title = 'Admin Console: App Detail';
    this.getAppData();
  },
  computed: {
    releaseNotes () {
      return appstore.getReleaseNotes(this.activeVersion);
    }
  },
  mounted: function () {
    this.isAdmin = general.isAdmin();
    this.getAppInformation();
  },
  methods: {
    getReleaseDate (date) {
      return dateToStringWithTimeFull(new Date(date));
    },
    getAppInformation () {
      this.isLoading = true;
      this.appId = this.$route.params.id;
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${this.appId}`)
        .then(response => {
          this.appInformation = response.data.data.app;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(this.isLoading = false);
    },
    getAppData () {
      this.isLoading = true;
      this.appId = this.$route.params.id;
      this.isDetail = !!this.appId;
      if (this.isDetail) {
        this.currentApp = JSON.parse(sessionStorage.getItem('app'));
        if ('ios' === this.currentApp.platform) {
          this.appExtAllow = 'Choose or drop ipa file to upload';
        } else if ('android' === this.currentApp.platform) {
          this.appExtAllow = 'Choose or drop apk file to upload';
        }
        if (!this.currentApp.noVersion || false === this.currentApp.noVersion) {
          this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${this.appId}/version`, {
            headers: {
              Accept: 'application/json'
            }
          }).then(response => {
            let versions = response.data.data.versions;
            this.listAppVersions = versions;
            let currentVersionIndex = this.listAppVersions.findIndex(this.findVersion);
            if (currentVersionIndex < 0) {
              currentVersionIndex = 0;
              this.currentVersionText = 'Lastest Version';
            }
            this.activeVersion = this.listAppVersions[currentVersionIndex];
            if (!this.activeVersion) {
              this.activeVersion = {};
              this.currentApp.noVersion = true;
            }
            this.currentVersion = this.activeVersion;
            this.currentVersion = appstore.getPreviousVersion(currentVersionIndex, this.currentVersion, this.listAppVersions);
            this.activeId = this.activeVersion.id;
          }).catch(error => {
            console.log(error);
          });
        }
        this.isLoading = false;
      }
    },
    findVersion (v) {
      return v.id === this.versionId;
    },
    goToUpload () {
      this.$router.push({ name: 'apps-upload' });
    },
    goToAppLanding () {
      let routeToAppLanding = this.getRouteToLanding();
      window.open(routeToAppLanding, '_blank');
    },
    goToDetail () {
      sessionStorage.setItem('appIcon', this.activeVersion.thumbnail);
      this.$router.push({ name: 'apps2-version-edit-2', params: { versionid: this.activeVersion.id } });
    },
    getRouteToLanding () {
      let routeObj = { name: this.routeAppsLandingWithVersion, params: { appid: this.appId, versionid: this.activeVersion.id } };
      if (this.current) {
        routeObj = { name: this.routeAppsLanding, params: { appid: this.appId } };
      }
      return this.$router.resolve(routeObj).href;
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    viewVersion (id) {
      this.versionId = id;
      this.activeVersion = this.listAppVersions.find(this.findVersion);
      this.activeVersion = appstore.getPreviousVersion(this.listAppVersions.findIndex(this.findVersion), this.activeVersion, this.listAppVersions);
      this.activeId = id;
      this.current = false;
      if (this.activeVersion.isCurrent) {
        this.current = true;
      } else {
        this.goToDetail();
      }
    },
    seeCurrent () {
      this.activeVersion = this.currentVersion;
      this.versionId = this.activeVersion.id;
      this.activeId = this.versionId;
      this.current = true;
    },
    setCarouselImages (screenshots) {
      this.images = [];
      for (let i = 0; i < screenshots.length; i++) {
        let screenshot = screenshots[i];
        this.images.push({
          id: screenshot.id,
          big: screenshot.url,
          thumb: screenshot.url
        });
      }
      this.showCarousel = screenshots.length > 0;
    },
    deleteApp () {
      if (this.appId) {
        axios({
          method: 'delete',
          url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.appId)
        }).then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.removeSessionStorageApp();
            this.alertMessage = 'Application has been successfully deleted.';
            this.showAlert = true;
            this.$router.push({ name: this.routeAppsHome });
          }
        })
          .catch(error => console.log(error));
      }
    },
    confirmedDelete () {
      if ('app' === this.delTarget) {
        this.deleteApp();
      }
    },
    requestDeleteConfirmBox (t) {
      this.delTarget = t;
      this.showConfirmBox = true;
    },
    goToNewVersion () {
      this.$router.push({ name: this.routeAppsVersion, params: { id: this.appId } });
    },
    goToEditVersion () {
      this.$router.push({ name: this.routeAppsVersionEdit, params: { id: this.appId, versionid: this.activeVersion.id } });
    },
    goToEditApp () {
      this.$router.push({ name: this.routeAppsEdit, params: { id: this.appId } });
    },
    goToNewApp () {
      this.$router.push({ name: this.routeAppsCreate });
    },
    copyAppDetail (e) {
      let fullUrl = window.location.origin + this.getRouteToLanding().href;
      let fullTextToCopy = this.currentApp.name + ' ' + this.activeVersion.version + ' \r\n' + fullUrl + ' \r\nPIN : ' + this.activeVersion.pin;
      this.$clipboard(fullTextToCopy);

      let btnId = e.currentTarget.id;
      this.tooltipTextCopyApp = 'Copied!';
      if ('copyAppBtn2' === btnId) {
        this.$refs.copyAppTooltip2.$emit('open');
      }
      if ('copyAppBtn' === btnId) {
        this.$refs.copyAppTooltip.$emit('open');
      }
      setTimeout(() => {
        this.tooltipTextCopyApp = 'Copy App Detail';
      }, 3000);
    },
    copyPin () {
      this.$clipboard(this.activeVersion.pin);
      this.tooltipTextCopyPIN = 'Copied!';
      this.$refs.copyPinTooltip.$emit('open');
      setTimeout(() => {
        this.tooltipTextCopyPIN = 'Copy PIN';
      }, 5000);
    },
    processFileInput (e) {
      this.file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
      if (this.file) {
        this.setFileInfo(this.file);
      }
    },
    async setFileInfo (file) {
      const fname = file.name;
      const ext = fname.slice((fname.lastIndexOf('.') - 1 >>> 0) + 2);
      const parser = new AppInfoParser(file);
      parser.parse().then(result => {
        if ('ipa' === ext) {
          // set for ipa
          this.appVersion.fileName = fname;
          this.appVersion.bundleId = result.CFBundleIdentifier;
          this.appVersion.compatibility = result.mobileProvision.Platform[0] + ' ' + result.MinimumOSVersion;
          this.appVersion.version = result.CFBundleShortVersionString + ' (' + result.CFBundleVersion + ')';
          this.appVersion.platform = result.mobileProvision.Platform[0];
          this.appVersion.name = result.CFBundleName;
          if (result.icon) {
            this.appVersion.thumbnail = result.icon;
          } else {
            this.appVersion.thumbnail = null;
          }
          this.appVersion.file = file;
          this.$router.push({ name: 'apps2-create-edit', params: { appMeta: this.appVersion } });
        }

        if ('apk' === ext) {
          // set for apk
          this.appVersion.fileName = fname;
          this.appVersion.bundleId = result.package;
          this.appVersion.version = result.versionName + ' (' + result.versionCode + ')';
          this.appVersion.compatibility = result.usesSdk.minSdkVersion;
          this.appVersion.platform = 'Android';
          this.appVersion.name = Array.isArray(result.application.label) ? result.application.label[0] : result.application.label;
          if (result.icon) {
            this.appVersion.thumbnail = result.icon;
          } else {
            this.appVersion.thumbnail = null;
          }
          this.appVersion.file = file;
          this.$router.push({ name: 'apps2-create-edit', params: { appMeta: this.appVersion } });
        }
      }).catch(err => {
        console.log('err ----> ', err);
      });
    },
    removeSessionStorageApp () {
      sessionStorage.removeItem('app');
    }
  },
  watch: {
    '$route' (to, from) {
      this.getAppData();
    }
  },
  components: {
    'app-loading': Loading,
    'app-confirm': ConfirmBox
  }
};
</script>
<!--style scoped src="@/assets/css/appstore-simdetail.css"></style-->
<style>
  .versionRow:hover {
    cursor: pointer;
    background-color: #fafafa;
  }
  .versionRow {
    margin-top: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    padding-bottom: 7px;
  }
  .appSummary {
    margin-top: 10px;
  }
  .thumbnail-rounded {
    border-radius: 24px;
  }
  .main {
    background-color: #fff;
  }
  .mt-4-border {
    border-bottom: 1px solid rgba(0,0,0,0.1);
    padding-bottom: 14px;
  }
  .right-link-buttons {
    float: right;
  }
</style>
